import { Box, BoxProps } from '@tapresearch/ui/components';
import React, { useMemo } from 'react';

import { QualificationWithQualificationAnswers } from '../../../../api/QualificationAPI';
import { FilterMultipleSelector } from '../../../common/Filter';

export interface QualificationSelectorProps extends BoxProps {
  qualification: QualificationWithQualificationAnswers;
  isDisabled?: boolean;
}

export function QualificationSelector({
  qualification,
  isDisabled = false,
  ...rest
}: QualificationSelectorProps) {
  const options = useMemo(
    () =>
      (qualification.attributes.custom_qualification_answers
        ? qualification.attributes.custom_qualification_answers
        : qualification.attributes.qualification_answers.sort((a, b) =>
            a.attributes.order_priority < b.attributes.order_priority ? -1 : 1
          )
      ).map((qAnswer) => ({
        value: qAnswer.attributes.pre_code.toString(),
        label: qAnswer.attributes.option_text,
      })),
    [
      qualification.attributes.qualification_answers,
      qualification.attributes.custom_qualification_answers,
    ]
  );

  return (
    <Box {...rest} m="0">
      <FilterMultipleSelector
        options={options}
        isDisabled={isDisabled}
        name={qualification.attributes.question_id.toString()}
        data-testid={`qualification-${qualification.id}-filter`}
        m="0"
      />
    </Box>
  );
}
